<template>
    <div v-wechat-title="title">
        <div style="margin: 5px">
            <div style="text-align: left">
                <span v-if="this.isaddevent == true || this.isaddevent == `True`"><i style="color: red">*</i>确认时间</span>
                <span v-else><i style="color: red">*</i> “{{ this.data.event_name }}”事件时间调整</span>
            </div>
            <div>
                <item-input type="datetime-local" v-model="eventtime" style="width: 300px; height: 40px; margin-top: 40px; font-size: 20px"></item-input>
            </div>
        </div>
        <CloseButton :loading="btnloading" ref="close-btn" type="confirm" @confirm="SaveOccurEventByEventid" :data="data" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
export default {
    name: `KeyEventUpdateTime`,
    props: {},
    data() {
        return {
            title: `事件时间调整`,
            token: this.$route.query.token,
            surgeryid: this.$route.query.surgeryid,
            record_type: this.$route.query.record_type,
            ispy: this.$route.query.ispy,
            isaddevent: this.$route.query.isaddevent,
            eventid: this.$route.query.eventid,
            outRoomTimeDelayMinute: this.$root.OutRoomTimeDelayMinute,
            eventtime: new Date(),
            btnloading: false,
            msg: `closeWindow`,
            data: {}
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
        this.LoadEventTime()
    },
    computed: {},
    methods: {
        LoadEventTime() {
            if (this.surgeryid && this.eventid) {
                let that = this
                if ((this.isaddevent == true || this.isaddevent == `True`)) {
                    this.title = `确认时间`
                    this.eventtime = new Date()
                } else {
                    let req = that.myaxios.get(`/api/Intraoperative/Anaesthesia/GetOccurEventByEventid?surgeryid=${this.surgeryid}&eventid=${this.eventid}`)
                    req.then(data => {
                        this.title = `事件时间调整`
                        that.data = data
                        this.eventtime = this.$moment(this.data.occur_time).format(`YYYY/MM/DD HH:mm`)
                        if (this.data.dic_event_id == `6` && this.outRoomTimeDelayMinute > 0 && this.data.last_event_time != null && (this.ispy == true || this.ispy == `True`)) {
                            this.eventtime = this.$moment(this.data.last_event_time).add(this.outRoomTimeDelayMinute, `minutes`).format(`YYYY/MM/DD HH:mm`)
                        }
                        this.eventtime = new Date(this.eventtime)
                    }).catch(e => {
                        console.log(e)
                    })
                }
            }
        },
        SaveOccurEventByEventid() {
            let that = this
            this.btnloading = true
            return new Promise(resolve => {
                let eventtime = this.$moment(this.eventtime).format(`YYYY/MM/DD HH:mm`)
                console.log(eventtime)
                let isadd = false
                if ((this.isaddevent == true || this.isaddevent == `True`)) {
                    isadd = true
                }
                // let req = that.myaxios.get(`/api/Intraoperative/Anaesthesia/CheckBeforeOccurEvent?surgeryid=${this.surgeryid}&eventid=${this.eventid}&isaddevent=${isadd}&record_type=${this.record_type}`)
                // req.then(data => {
                //     let sendInfo = {
                //         surgeryid: this.surgeryid,
                //         eventid: this.eventid,
                //         isaddevent: isadd,
                //         record_type: this.record_type,
                //         occurtime: eventtime,
                //         urlstr: `/api/Intraoperative/Anaesthesia/SaveOccurEventByEventid?surgeryid=${this.surgeryid}&eventid=${this.eventid}&isaddevent=${isadd}&record_type=${this.record_type}&occurtime=${eventtime}`
                //     }
                //     that.beforeSaveSendMessage(sendInfo)
                // }).catch(e => {
                //     this.btnloading = false
                //     console.log(e)
                // })

                let sendInfo = {
                    surgeryid: this.surgeryid,
                    eventid: this.eventid,
                    isaddevent: isadd,
                    record_type: this.record_type,
                    occurtime: eventtime,
                    urlstr: `/api/Intraoperative/Anaesthesia/SaveOccurEventByEventid?surgeryid=${this.surgeryid}&eventid=${this.eventid}&isaddevent=${isadd}&record_type=${this.record_type}&occurtime=${eventtime}`
                }
                that.beforeSaveSendMessage(sendInfo)
            })
        },
        beforeSaveSendMessage(sendInfo) {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    action: `beforeevent`,
                    data: sendInfo
                }
                winformMsg.acceptMessage(cefJson)
                this.$refs[`close-btn`].close()
            }
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    action: `event`,
                    data: { id: this.data.id }
                }
                winformMsg.acceptMessage(cefJson)
                this.$refs[`close-btn`].close()
            }
        }
    },
    watch: {}
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 5px;
}
.inputStyle {
    margin-top: 60px !important;
    width: 65px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/KeyEventUpdateTime.vue